// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c0d0dacf","977":"d2439ae6"}[chunkId] + ".chunk.js";
};